import React from "react";
import GenericPullAndPushToolView from "../GenericPullAndPushToolView";
import SentinelOneCredentialsForm from "./SentinelOneCredentialsForm";
import SentinelOneConfigListing from "./SentinelOneConfigListing";

const SentinelOnePullAndPushView = (props) => (
  <GenericPullAndPushToolView
    {...props}
    PullCredentialForm={SentinelOneCredentialsForm}
    PullConfigListingView={SentinelOneConfigListing}
  />
);

export default SentinelOnePullAndPushView;
